import React from 'react';
import { isNull, isUndefined } from 'lodash';
import { Container } from 'react-bootstrap';

import { Loading, LoadingError, BackButton } from '@components/Base';
import SupportSection from '@components/SupportSection';

import { routePersonalAccidentQuoteBuyNewPage } from '@components/PersonalAccidentQuoteBuyRoute';
import { HeaderSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/header-section';
import { ExclusionSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/exclusion-section';
import { DocumentSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/document-section';
import { HospitalSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/hospital-section';
import { MemberSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/member-section';
import { useQuoteOptionParams } from '@components/Feature/HealthQuote';

import { usePersonalAccidentQuoteFind } from '../hook';
import { routePersonalAccidentQuoteSendEmailPage } from '../route';
import { routePersonalAccidentQuotePage } from '../../HealthQuotePage/route';
import { FeatureSection } from './feature-section';
import { BenefitSection } from './benefit-section';

const PersonalAccidentQuoteDetailsPage = () => {
  const params = useQuoteOptionParams();
  const personalAccidentQuote = usePersonalAccidentQuoteFind();

  if (isUndefined(personalAccidentQuote)) return <Loading />;
  if (isNull(personalAccidentQuote)) return <LoadingError />;

  const { personalAccidentPlanId, personalAccidentPlanName } = personalAccidentQuote;

  return (
    <>
      <Container className="mt-4">
        <BackButton className="mb-4" />
      </Container>

      <HeaderSection
        {...personalAccidentQuote}
        planName={personalAccidentPlanName}
        buyLinkTo={routePersonalAccidentQuoteBuyNewPage({ ...params, personalAccidentPlanId })}
        sendEmailLinkTo={routePersonalAccidentQuoteSendEmailPage({ ...params, personalAccidentPlanId })}
      />
      <FeatureSection {...personalAccidentQuote} />
      <BenefitSection {...personalAccidentQuote} />
      <ExclusionSection {...personalAccidentQuote} />
      <DocumentSection {...personalAccidentQuote} />
      <HospitalSection {...personalAccidentQuote} />
      <MemberSection {...personalAccidentQuote} formLinkTo={routePersonalAccidentQuotePage({ path: 'members', ...params })} />

      <SupportSection />
    </>
  );
};

export { PersonalAccidentQuoteDetailsPage };
